module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-am-ef04188e57d4135af8d1b5aa5c2dc54e.png";